import { render } from "./whats-app-create-message.vue?vue&type=template&id=67e8e978&scoped=true"
import script from "./whats-app-create-message.vue?vue&type=script&lang=js"
export * from "./whats-app-create-message.vue?vue&type=script&lang=js"

import "./whats-app-create-message.vue?vue&type=style&index=0&id=67e8e978&lang=css"
import "./whats-app-create-message.vue?vue&type=style&index=1&id=67e8e978&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e8e978"]])

export default __exports__